import { useEffect } from "react";
import { useSite } from "../context/SiteContext";

/**
 * Loads the Tawk.to live chat widget when siteConfig.liveChat.tawkPropertyId is set.
 * With an empty ID nothing is loaded (no external script, no chat bubble).
 */
const LiveChat = () => {
  const { config } = useSite();
  const { tawkPropertyId, tawkWidgetId = "default" } = config.liveChat || {};

  useEffect(() => {
    if (!tawkPropertyId || document.getElementById("tawk-script")) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.id = "tawk-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${tawkPropertyId}/${tawkWidgetId}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.body.appendChild(s);
  }, [tawkPropertyId, tawkWidgetId]);

  return null;
};

export default LiveChat;
